import { FC, useEffect, useState } from "react";
import StatsReports from "../statsReports";
import { Controller, useForm } from "react-hook-form";
// import HubInputField from "src/components/inputType";
import Select from "react-select";
import { format, parse } from "date-fns";
import { TerritoriesPropsType, TerritoriesSearchProps } from "./types";
import DatePicker from "react-datepicker";
import ReactInputMask from "react-input-mask";
const TerritoriesFilter: FC<TerritoriesPropsType> = ({
    updateQueryParams,
    defaultQueryParams,
}): JSX.Element => {
    const { control, handleSubmit, getValues, reset, watch } = useForm<TerritoriesSearchProps>({
        mode: "all",
        defaultValues: defaultQueryParams,
    });

    useEffect(() => {
        if (!defaultQueryParams) {
            return;
        }
        reset(defaultQueryParams);
    }, [defaultQueryParams, reset]);


    const start_date = watch("start_date");
    const end_date = watch("end_date");
    // const timeData = [
    //     { value: "day", label: "Day" },
    //     { value: "week", label: "Week" },
    //     { value: "month", label: "Month" },
    //     { value: "quarter", label: "Quarter" },
    // ];

    const timeData = [
        { value: "day", label: "Daily" },
        { value: "week", label: "Weekly" },
        { value: "month", label: "Monthly" },
        { value: "quarter", label: "Quarterly" },
    ];
    const periodData = [
        { value: 'p-1', label: 'vs Previous Period' },
        { value: 'y-1', label: 'vs Previous Year' },
    ]
    const filterCaseData = [
        { value: "all", label: "All Cases" },
        { value: "ecrall", label: "ECR Cases" },
        { value: "ncrall", label: "Non-ECR Cases" },
        { value: "parecrall", label: "PA Pending" },
        { value: "ncrparall", label: "Missing Docs" },
    ];


    const [startOpen, setStartOpen] = useState(false);
    const [endOpen, setEndOpen] = useState(false);

    const closeDatePickers = () => {
        setStartOpen(false);
        setEndOpen(false);
    };

    // const clearFormData = () => {
    //     const values = {
    //         start_date: format(
    //             new Date().setDate(new Date().getDate() - 60),
    //             "yyyy-MM-dd"
    //         ),
    //         end_date: format(
    //             new Date().setDate(new Date().getDate()+1),
    //             "yyyy-MM-dd"
    //         ),
    //         period: "day",
    //         filter: "",
    //         filter_type: "",
    //         // time: "",
    //         case_id: "",
    //         search_str: "",
    //         type: defaultQueryParams?.type,
    //         role: defaultQueryParams?.role,
    //         id: defaultQueryParams?.id,
    //     };

    //     reset(values);
    //     updateQueryParams(getValues(), true);
    // };

    const searchForStats = (values: TerritoriesSearchProps) => {
        const updatedValues = {
            ...values,
            period: values.period
                ? typeof values.period === "string"
                    ? values.period
                    : (values.period as unknown as { value: string; label: string }).value
                : "",
            filter_type:
                values.filter_type ?
                    (typeof values.filter_type === "string" ? values.filter_type : (values.filter_type as unknown as { value: string; label: string; }).value)
                    : "",
            filter: values.filter
                ? typeof values.filter === "string"
                    ? values.filter
                    : (values.filter as unknown as { value: string; label: string }).value
                : "",
        };

        updateQueryParams(updatedValues, false);
    };


    return (
        <form onSubmit={handleSubmit(searchForStats)}>
            <div className="card mt-4">
                <div className="card-header bg-success-subtle">
                    <h4 className="m-0 text-black">Statistics</h4>
                </div>
                <div className="card-body px-3 pt-3">
                    <div className="row gx-2 statistics-filter">
                        <div className="col date-col mb-3 position-relative">
                            <Controller
                                name="start_date"
                                control={control}
                                defaultValue=""
                                render={({ field }) => (
                                    // <HubInputField
                                    //     inputId="start_date"
                                    //     isRowBased={false}
                                    //     isRequired={false}
                                    //     field={field}
                                    //     inputType="date"
                                    // />
                                    <>
                                    <DatePicker
                                        selected={field.value.length > 0 ? parse(field.value, "yyyy-MM-dd", new Date()) : null}
                                        onChange={(date) => date ? field.onChange(format(date, "yyyy-MM-dd")) : ""}
                                        customInput={
                                            <ReactInputMask mask="99/99/9999">{(inputProps: {}) =>
                                                <input {...inputProps} />}
                                            </ReactInputMask>
                                        }
                                        className="form-control rounded-1" wrapperClassName="w-100"
                                        placeholderText="mm/dd/yyyy"
                                        dateFormat="MM/dd/yyyy"
                                        showMonthDropdown
                                        showYearDropdown
                                        maxDate={end_date ? new Date(end_date) : undefined}
                                        open={startOpen}
                                        onFocus={() => {
                                            setStartOpen(true);
                                            setEndOpen(false);
                                        }}
                                        onClickOutside={() => setStartOpen(false)}
                                        onSelect={() => setStartOpen(false)}

                                    />
                                     <i
                                            className="bi bi-calendar position-absolute"
                                            style={{
                                                right: "10px",
                                                top: "50%",
                                                transform: "translateY(-50%)",
                                                pointerEvents: "none",
                                            }}
                                        ></i>
                                        </>
                                    
                                )}
                            />
                            
                        </div>
                        <div className="col date-col mb-3 position-relative">
                            <Controller
                                name="end_date"
                                control={control}
                                defaultValue=""
                                render={({ field }) => (
                                    // <HubInputField
                                    //     inputId="end_date"
                                    //     isRowBased={false}
                                    //     isRequired={false}
                                    //     field={field}
                                    //     inputType="date"
                                    // />
                                    <>
                                    <DatePicker
                                        selected={field.value.length > 0 ? parse(field.value, "yyyy-MM-dd", new Date()) : null}
                                        onChange={(date) => date ? field.onChange(format(date, "yyyy-MM-dd")) : ""}
                                        customInput={<ReactInputMask mask="99/99/9999">{(inputProps: {}) =>
                                            <input {...inputProps} />}</ReactInputMask>}
                                        className="form-control rounded-1" wrapperClassName="w-100"
                                        placeholderText="mm/dd/yyyy"
                                        dateFormat="MM/dd/yyyy"
                                        showMonthDropdown
                                        showYearDropdown
                                        minDate={start_date ? new Date(start_date) : undefined}
                                        open={endOpen}
                                        onFocus={() => {
                                            setEndOpen(true);
                                            setStartOpen(false);
                                        }}
                                        onClickOutside={() => setEndOpen(false)}
                                        onSelect={() => setEndOpen(false)}
                                    />
                                    <i
                                            className="bi bi-calendar position-absolute"
                                            style={{
                                                right: "10px",
                                                top: "50%",
                                                transform: "translateY(-50%)",
                                                pointerEvents: "none",
                                            }}
                                        ></i>
                                        </>
                                )}
                            />
                        </div>
                        <div className="col mb-3 filters-col m-0">
                             <Controller
                                name="period"
                                control={control}
                                defaultValue={timeData?.[0]?.value || ""}
                                render={({ field }) => (
                                    <Select
                                        isClearable={true}
                                        options={
                                            timeData?.map((item) => ({
                                                value: item.value,
                                                label: item.label,
                                            })) || []
                                        }
                                        id="period"
                                        {...field}
                                        onChange={(selectedOption) => field.onChange(selectedOption?.value || "")}
                                        value={
                                            timeData?.find((option) => option.value === field.value) || null
                                        }
                                        onFocus={closeDatePickers}
                                    />
                                )}
                            /> 
                        
                           
                        </div>
                        <div className="col mb-3 filters-col m-0">
                            <Controller
                                name="filter_type"
                                control={control}
                                defaultValue={timeData[0].value}
                                render={({ field }) => (
                                    <Select
                                        isClearable={true}
                                        options={
                                            periodData.map((item) => ({
                                                value: item.value,
                                                label: item.label,
                                            })) || []
                                        }
                                        id="filter_type"
                                        {...field}
                                        onChange={(selectedOption) => field.onChange(selectedOption?.value || "")}
                                        value={
                                            periodData?.find((option) => option.value === field.value) || null
                                        }
                                        onFocus={closeDatePickers}
                                    />
                                )}
                            />
                        </div>
                        <div className="col mb-3 filters-col m-0">
                            <Controller
                                name="filter"
                                control={control}
                                render={({ field }) => (
                                    <Select
                                        isClearable={true}
                                        options={
                                            filterCaseData.map((item) => ({
                                                value: item.value,
                                                label: item.label,
                                            })) || []
                                        }
                                        id="filter"
                                        {...field}
                                        onChange={(selectedOption) => field.onChange(selectedOption?.value || "")}
                                        value={
                                            filterCaseData?.find((option) => option.value === field.value) || null
                                        }
                                        placeholder={"Filter ..."}
                                        onFocus={closeDatePickers}
                                    />
                                )}
                            />
                        </div>
                        <div className="col date-col mb-3 m-0">
                            <Controller
                                name="search_str"
                                control={control}
                                defaultValue=""
                                render={({ field }) => (
                                    // <HubInputField
                                    //     inputId="search_str"
                                    //     isRowBased={false}
                                    //     isRequired={false}
                                    //     field={field}
                                    //     inputType="text"
                                    //     inputPlaceholder="Pt. ID or Doctor"
                                    // />
                                    <input className="form-control" type={"text"} id={'search_str'} placeholder={'Pt. ID or Doctor'}  {...field} onFocus={closeDatePickers} />

                                )}
                            />
                        </div>
                        <div className="col date-col mb-3 m-0">
                            <Controller
                                name="case_id"
                                control={control}
                                defaultValue=""
                                render={({ field }) => (
                                    // <HubInputField
                                    //     inputId="case_id"
                                    //     isRowBased={false}
                                    //     isRequired={false}
                                    //     field={field}
                                    //     inputType="text"
                                    //     inputPlaceholder="Case ID"
                                    // />
                                    <input className="form-control" type={"text"} id={'case_id'} placeholder={'Case ID'}  {...field} onFocus={closeDatePickers} />

                                )}
                            />
                        </div>
                        <div className="col filter-buttons mb-3 m-0 d-flex gap-2">
                            {/* <button type="button" className="btn btn-light text-nowrap"
                                onClick={() => clearFormData()}>
                                <i className="bi bi-eraser-fill"></i> Clear
                            </button> */}
                            <button type="submit" className="btn btn-blue text-nowrap">
                                <i className="fas fa-sync-alt"></i> Refresh
                            </button>
                        </div>
                    </div>
                    <StatsReports getValues={getValues} />
                </div>
            </div>
        </form>
    );
};

export default TerritoriesFilter;
